<app-terminal-overlay
    [title]="title() | translate"
    subtitle="{{ 'GENERAL.SUBTITLE.SELECT_EMPLOYEE' | translate }}"
    icon="fa-user"
    [activityType]="activityType()"
    [isFinishVisible]="false"
    (closeRequested)="onCloseRequested()"
>
    <priva-filter-search
        header
        [config]="filterSearchConfig"
        [dataSource]="employeeDataSource"
        data-test="employee-search-bar"
    />

    <div class="employee-selector__overview">
        @for (employeeGroup of employeeGroups$ | async; track employeeGroup.groupName) {
            <app-employee-group
                [employeeGroup]="employeeGroup"
                (employeeSelected)="onEmployeeSelected($event)"
                (groupTitleClicked)="showNavigation($event)"
                data-test="employee-group"
            />
        }
    </div>
    @if (isNavigating) {
        <app-employee-navigation
            [employeeGroups]="(employeeGroups$ | async) ?? []"
            (closeNavigation)="hideNavigation()"
            (navigate)="onNavigateToEmployeeGroup($event)"
        />
    }
</app-terminal-overlay>
